import { settingsNavGroups } from '@/config/settings-nav.config';
import { usePermissions } from '@/hooks/use-permissions';
import { useSubjectVisibility } from '@/hooks/use-visible-sub-items';
import SecondarySidebarLayout from './secondary-sidebar-layout';
import type { SecondarySidebarGroup } from './secondary-sidebar-layout';

export default function SettingsLayout() {
	const { isSuperAdmin, role } = usePermissions();
	const isAdmin = isSuperAdmin || role === 'administrator';
	const isVisible = useSubjectVisibility();

	const visibleGroups: SecondarySidebarGroup[] = settingsNavGroups
		.map((group) => ({
			heading: group.heading,
			items: group.items.filter((item) => {
				if (item.superAdminOnly) return isSuperAdmin;
				if (item.adminOnly && !isAdmin) return false;
				return isVisible(item.subject);
			})
		}))
		.filter((group) => group.items.length > 0);

	return <SecondarySidebarLayout title='Settings' groups={visibleGroups} groupDividers />;
}
